import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import TimezoneForm from './TimezoneForm';

function Timezone() {
  const navigate = useNavigate();
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [userTimezone, setUserTimezone] = useState('');

  const handleUpdateSuccess = (email, timezone) => {
    const encodedEmail = encodeURIComponent(email).replace(/%2B/g, '+');
    navigate(`/timezone-success?email=${encodedEmail}&timezone=${encodeURIComponent(timezone || '')}`);
  };

  return (
    <>
      <section className="theme-light section m-0 p-0" data-theme="light">
        <div className='fullHeight m-0 p-0 is-flex is-flex-direction-column is-justify-content-space-between'>
          <div>
            {/* Navigation */}
            <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
              <div className="m-0 p-0 column is-11 is-offset-1"><Navigation /></div>
            </div>
            
            {/* Content */}
            <div className='pb-6 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
              <div className="m-0 p-0 content column is-4-fullhd is-4-widescreen is-6-desktop is-8-tablet is-10-mobile">
                <h1 className='pt-4 px-0 pb-0 m-0'>
                  {updateSuccess ? 'Timezone updated' : 'Update your timezone'}
                </h1>
                <h3 className='py-2 px-0 m-0 is-bold'>
                    Time zones matter—Unless you enjoy 3 AM Nudges
                </h3>
                <p>
                    Set your timezone so Nudgemail knows <span className='is-italic'>exactly</span> when to deliver your reminders—no more surprise early morning Nudges (unless that's your thing). No matter where you are, we will ensure your Nudges land right on time. ⏰🚀
                </p>
                <TimezoneForm onSignupSuccess={handleUpdateSuccess} showForm={!updateSuccess} />
              </div>
            </div>
          </div>
          
          {/* Footer */}
          <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
            <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Timezone;